import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import SelecionarMotorista from "./pages/SelecionarMotorista";
import EscolherAcao from "./pages/EscolherAcao";
import Apontamentos from "./pages/Apontamentos";
import EventosAtuais from "./pages/EventosAtuais";
import EditarApontamento from "./pages/EditarApontamentos"; // Página de edição
import PortalSsoPage from "./pages/PortalSsoPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<SelecionarMotorista />} />
      <Route path="/sso-login" element={<PortalSsoPage />} />
      <Route
        path="/interno/selecionar-motorista"
        element={<Navigate to="/" replace />}
      />
      <Route
        path="/externo/selecionar-motorista"
        element={<Navigate to="/" replace />}
      />
      <Route
        path="/teste/selecionar-motorista"
        element={<Navigate to="/" replace />}
      />
      <Route
        path="/:codigo/escolher-acao" // Rota para escolher a ação
        element={<EscolherAcao />} // Página que irá permitir escolher entre apontamentos ou eventos
      />
      <Route
        path="/:codigo/apontamentos" // Rota para a página de apontamentos
        element={<Apontamentos />} // Página que irá mostrar os apontamentos
      />
      <Route
        path="/:codigo/eventos-atuais" // Rota para a página de eventos atuais
        element={<EventosAtuais />} // Página que irá mostrar os eventos atuais
      />
      {/* Rota de edição com data_inicial e index como parâmetros */}
      <Route
        path="/editar/:dataInicial/" // Rota para edição com os parâmetros
        element={<EditarApontamento />} // Página que irá editar os apontamentos
      />
    </Routes>
  );
}

export default App;
